import React from "react";
import CheckboxForm from "../../../Dashboard/CheckboxForm";

// TODO: This needs to modified to use contexts or something so we dont have all this prop drilling
export default function EstimatedSavings({
  isCash,
  view,
  viewOptions,
  loanA,
  loanB,
  loanAmount,
  mappedLoans1,
  mappedLoans2,
  sungagePayments,
  lightReachQuote,
  years,
  loan1Bills,
  loan2Bills,
  postYears,
  postYears1,
  loan1Savings,
  loan2Savings,
  setLoanAId,
  setLoanBId,
  total,
  uType,
  customerState = "",
  batteryCount = 0,
  pricingDisclosures,
  lifetimeWithoutCost,
  lifetimeSolarCost,
  lifeTimeUtilityAfterCost,
  lifetimeAvoidedCost }) {

  const EstimatedSavingsLoan = ({ loan, option, setLoanId, mappedLoans, loanBills, loanSavings }) => {
    // {/* Dropdown loan select  */}
    return (
      <>
        <div className="col">
          <div className={isCash ? "noDisplay" : "financeContainer"}>
            {+view === 1 ? (
              <>
                <div className="costs v6 black selects">
                  <select
                    className="finInput loans"
                    onChange={(e) => setLoanId(e.target.value)}
                  >
                    <option
                      style={{
                        display: "none",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      {+viewOptions === 0 ? `OPTION ${option} |` : ""}{" "}
                      {loan.loanName}{" "}
                      {+loan.loanId === 115
                        ? null
                        : +loan.isPpa === 1
                          ? `$${loan.ppaRate} ${(+loan.ppaEscalator * 100)
                            .toFixed(2)}%`
                          : `${+loan.loanTerm} YR ${+loan.loanInterest}% APR`}
                    </option>
                    {mappedLoans}
                    <option value={0}>
                      {" "}
                      {viewOptions === 0 ? `OPTION ${option} |` : ""} Cash
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <>
                <div className="costs v6 black">
                  <div className="costsText v6 black">
                    {viewOptions === 0 ? (
                      <span className="d-none d-lg-inline costsText v6 black">
                        {" "}
                        OPTION {option} |
                      </span>
                    ) : (
                      ""
                    )}{" "}
                    {loan.loanName}{" "}
                    {+loan.loanId === 115
                      ? null
                      : +loan.isPpa === 1
                        ? `$${loan.ppaRate} ${(+loan.ppaEscalator * 100)
                          .toFixed(2)}%`
                        : `${+loan.loanTerm} YR ${+loan.loanInterest}% APR`}
                  </div>
                </div>
              </>
            )}
            {/* Solar Payment row  */}
            <div className="costs v6 gray">
              <div className="costsText v6 gray">
                $
                {(() => {
                  // this madness removes a useEffect error
                  if (sungagePayments !== null) {
                    return Math.round(
                      sungagePayments?.initialMonthlyPayment
                    );
                  } else if (
                    loan.loanName === "LightReach PPA" 
                  ) {
                    return Math.round(loan.firstMonthPayment);
                  } else if (loan.loanName === "GoodLeap PPA") {
                    return Math.round(loan.firstMonthPayment);
                  } else {
                    return Math.round(
                      +loan.isPpa === 1
                        ? loan.firstMonthPayment
                        : loan.prePayment * loanAmount
                    );
                  }
                })()}{" "}
                {loan.loanName === "Sunlight" ? "Estimated" : null}{" "}
                Solar Payment
              </div>
            </div>
            {/* YR Agreement  */}
            <div className="costs v6 dotted">
              <div className="costsText v6 dotted">
                {+loan.isPpa === 1
                  ? `$${+loan.ppaRate}/kWh`
                  : `${loan.loanTerm} Year Agreement Term`}
              </div>
            </div>
            {/* Monthly Payment w/o incentive  */}
            <div className="costs v6 dotted">
              <div className="costsText v6 dotted">
                $
                {(() => {
                  // this madness removes a useEffect error
                  if (sungagePayments !== null) {
                    return `${Math.round(
                      sungagePayments.continuingMonthlyPayment
                    )} Monthly Payment w/o Incentive`;
                  } else {
                    if (+loan.isPpa === 1) {
                      return `${(+loan.ppaEscalator * 100).toFixed(2)}% Escalator`;
                    } else {
                      return `${Math.round(loan.postPayment * loanAmount)} ${loan.loanName === "Sunlight"
                          ? "Estimated"
                          : ""
                        } Monthly Payment w/o Incentive`;
                    }
                  }
                })()}
              </div>
            </div>
            {/* 30 Cost with Utility*/}
            <div className="costs v6 dotted">
              <div className="costsText v6 dotted">
                {loan.loanTerm} Year Cost with Utility | $
                {
                  loan.isPpa === 1 && lifetimeWithoutCost
                    ? Math.round(lifetimeWithoutCost).toLocaleString(undefined)
                    : Math.round(total(years) * 12).toLocaleString(undefined)
                }
              </div>
            </div>
            {/* 30 Cost with ION */}
            <div className="costs v6 dotted">
              {loan ? (
                <div className="costsText v6 dotted">
                  {loan.loanTerm} Year Cost with ION | $
                  {
                    loan.isPpa === 1 
                      ? lifetimeSolarCost
                        ? Math.round(lifetimeSolarCost).toLocaleString(undefined)
                        : getPpaTotalCost(loan.firstMonthPayment, loan.ppaEscalator).toLocaleString(undefined)
                      : loan.totalAmount
                        ? Math.round(loan.totalAmount).toLocaleString(undefined)
                        : Math.round(total(loanBills) * 12).toLocaleString(undefined)
                  }
                </div>
              ) : (
                ""
              )}
            </div>
            {/* 30 Year Remaining Utility Cost */}
            <div className="costs v6 dotted">
              {total(postYears) * 12 <= 0 ? (
                <div className="costsText v6">
                  {loan.loanTerm} Year Remaining Utility Cost | $
                  {
                    lifeTimeUtilityAfterCost
                      ? Math.round(lifeTimeUtilityAfterCost).toLocaleString(undefined)
                      : Math.round(total(postYears1)).toLocaleString(undefined)
                  }
                </div>
              ) : (
                <div className="costsText v6">
                  {loan.loanTerm} Year Remaining Utility{" "}
                  <span className="d-none d-lg-inline costsText v6">
                    {" "}
                    Cost
                  </span>{" "}
                  | $
                  {
                    lifeTimeUtilityAfterCost
                      ? Math.round(lifeTimeUtilityAfterCost).toLocaleString(undefined)
                      : Math.round(total(postYears) * 12).toLocaleString(undefined)
                  }
                </div>
              )}
            </div>

            {/* Battery Rebate (LightReach + Texas) */}
            {(() => {
              const isLightReach = loan?.loanName?.toLowerCase()?.includes("lightreach");
              const showBatteryRebate =
                !isCash && customerState === "Texas" && +batteryCount > 0 && isLightReach;
              if (!showBatteryRebate) return null;
              const rebateMonthly = 54 * +batteryCount;

              return (
                <div className="costs v6 dotted">
                  <div className="costsText v6 dotted">
                    *Battery Rebate from Retail Energy Provider | $
                    {Math.round(rebateMonthly).toLocaleString(undefined)} per month
                  </div>
                </div>
              );
            })()}

            {/* 30 Year Solar Savings */}
            <div className="costs v6 blue">
              <div className="costsText v6 blue">
                {loan.loanTerm} Year Solar Savings:{" "}
                <span>
                  ${loan.loanName === "GoodLeap PPA" 
                  ? lifetimeAvoidedCost
                    ? Math.round(lifetimeAvoidedCost).toLocaleString(undefined)
                    : (Math.round((total(years) * .75 * 12) - (getPpaTotalCost(loan.firstMonthPayment, loan.ppaEscalator) + (total(postYears) * 12))).toLocaleString(undefined)) 
                  : (Math.round(loanSavings).toLocaleString(undefined))
                  }
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  const getPpaTotalCost = (firstMonthPayment, ppaEscalator, years = 25) => {
    let total = 0;
    let annualCost = firstMonthPayment * 12;
    for (let i = 0; i < years; i++) {
      total += annualCost;
      annualCost *= (1 + ppaEscalator);
    }
    return Math.round(total);
  };

  const Disclosures = () => {
    return (
      <>
        <div className="row">
          <div className="col">
            <div className="savingsText v7">
              {uType !== "Square Footage"
                ? "The calculations included in this proposal represent your estimated or actual utility power usage and costs and is based on information provided by you."
                : "The calculations included in this proposal represent your estimated utility power usage based on your livable square footage as provided by you. Cost savings estimates are based on costs related to your proposed solar system’s estimated production and your estimated utility needs based solely on your square footage. This is not based on your actual or historical power usage."}{" "}
              Missing or inaccurate data could result in projections
              that are different than your results and may result in a
              solar system that is smaller or larger than you may need.
              If you would like to update any information relied upon in
              creating this proposal, please let us know and we will
              prepare a revised/updated proposal.<br></br>
              <br></br>
              Savings are based on multiple factors and cannot be
              guaranteed.{" "}
              {uType === "Square Footage" &&
                "Net metering offerings of your specific utility also can influence your potential savings. You should verify with your utility regarding their net metering offerings and recognize that they may be subject to change."}{" "}
              Post-solar base utility fees are estimated by an
              industry-leading utility rate plan data provider. Net
              metering offerings of your specific utility also can
              influence your potential savings. You should verify with
              your utility regarding their net metering offerings and
              recognize that they may be subject to change.<br></br>
              <br></br>
              Depending on the system offset, additional post-solar
              utility costs are also assumed to apply and may change
              based on changes in your usage and/or changes made by your
              utility company. You should check with your utility for
              exact charges and/or changes.<br></br>
              <br></br>
              {/* The payment amount disclosed above assumes you make your
              incentive payment as provided in your loan agreement. If
              you do not make your incentive payment, your payment
              amount will increase. Please see your loan agreement for
              details regarding the timing and amount of your incentive
              payments. See also “Incentive Overview l Federal Tax
              Credit” section below. */}
              <br></br>
              {(loanA.loanName === "GoodLeap PPA" || loanA.loanName === "GoodLeap Lease") &&
                <CheckboxForm
                  disclosures={pricingDisclosures}
                  setAllChecked={f => f}
                />
              }

              {customerState === "Texas" &&
                +batteryCount > 0 &&
                !isCash &&
                (loanA?.loanName?.toLowerCase()?.includes("lightreach") ||
                  loanB?.loanName?.toLowerCase()?.includes("lightreach")) &&
                "*To receive the battery rebate you must switch your energy plan to the Palmetto Grid+ Retail Electricity Plan."}
              <br></br>
              {uType === "Square Footage" &&
                "Given your lack of sufficient utility power usage history in your home, this proposed solar system was designed based on calculations of your estimated utility needs based on your livable square footage."}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    // Title
    <>
      <div className="view7">
        <div className="container">
          <div className="row">
            <div className="col">
              {isCash ? null : (
                <div className="fontNew2 v7">Your Estimated Savings</div>
              )}
            </div>
          </div>
          <div className="costsContainer v7">
            <div className="row g-lg-5">
              {/* loanA data */}
              <EstimatedSavingsLoan
                loan={loanA}
                option={1}
                setLoanId={setLoanAId}
                mappedLoans={mappedLoans1}
                loanBills={loan1Bills}
                loanSavings={loan1Savings} />

              {/* loanB data  */}
              {viewOptions === 0 ? (
                <EstimatedSavingsLoan
                  loan={loanB}
                  option={2}
                  setLoanId={setLoanBId}
                  mappedLoans={mappedLoans2}
                  loanBills={loan2Bills}
                  loanSavings={loan2Savings} />
              ) : (
                <></>
              )}
            </div>
            <Disclosures />
          </div>
        </div>
      </div>
    </>
  );
};